import React from "react";
import { Container, Row, Table, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";
import ChangeButton from "presentation/components/buttons/change";

import SelectStudentEvaluationModal from "presentation/pages/classrooms/elements/select-student-evaluation-modal";

import { handleResultData, debounce } from "presentation/utils/functions/generic";

import classroomsService from "presentation/services/classrooms";
import classroomsStudentsService from "presentation/services/classroom-students";
import evaluationSchemesService from "presentation/services/evaluation-schemes";
import evaluationsService from "presentation/services/evaluations";

import { getEvaluationUniqueKey, handleEvaluationResultData } from "presentation/pages/classrooms/functions/classroom-evaluate-functions";

import {
  EVALUATION_AUTOSAVE_STATUS_IDLE,
  EVALUATION_AUTOSAVE_STATUS_PENDING,
  EVALUATION_AUTOSAVE_STATUS_SAVING,
  EVALUATION_AUTOSAVE_STATUS_SAVED,
  EVALUATION_AUTOSAVE_STATUS_ERROR
} from "presentation/model/constants";

class ClassroomEvaluateStudentMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      error: false,
      message: '',
      evaluationsData: [],
      students: [],
      periods: [],
      disciplines: [],
      formulaData: [],
      classroom: {
        name: ''
      },
      form: {
        studentId: undefined
      },
      currentStudentId: undefined,
      currentStudentName: undefined,
      currentStudentRegistration: undefined,
      showStudentSelectModal: false,
      pendingSaves: {},
      saveStatus: EVALUATION_AUTOSAVE_STATUS_IDLE,
      autoSaveMessage: ""
    };
    this.loadData = this.loadData.bind(this);
    this.closeStudentSelectModal = this.closeStudentSelectModal.bind(this);
    this.debouncedAutoSave = debounce(this.autoSaveEvaluation, 2000);
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    const { state } = this.props.location;
    const { studentId, studentName, studentRegistration } = state || [];

    this.setState({ currentStudentName: studentName, currentStudentRegistration: studentRegistration });

    await this.loadData(id, studentId);
  }

  loadData = async (classroomId, studentId) => {
    let classroomData = [];
    let studentsData = [];
    let formulaData = [];
    let disciplines = [];
    let evaluationsData = [];
    let periods = [];

    await classroomsService.findById(classroomId).then((result) => {
      classroomData = handleResultData(result);
    });

    await classroomsStudentsService.search({ classroomId: classroomId }).then((result) => {
      studentsData = handleResultData(result);
    });

    this.setState({ classroom: classroomData, students: studentsData });

    if (!studentId) {
      this.setState({ loading: false, showStudentSelectModal: true });
      return;
    }

    await evaluationsService.search({ classroomId: [classroomId], studentId: [studentId] }).then((evaluationResult) => {
      evaluationsData = handleEvaluationResultData(evaluationResult);
    });

    await evaluationSchemesService.getEvaluationFormulas(classroomId).then((evResult) => {
      formulaData = evResult?.periods || [];


      Array.from({ length: formulaData.length }, (_p, periodIndex) => {

        const { disciplineFormulas, ...periodInfo } = formulaData[periodIndex];

        const existingPeriod = periods.find(x => x.periodId == periodInfo.periodId);

        if (!existingPeriod) {
          periods.push(periodInfo);
        }

        let evaluationTypes = [];

        Array.from({ length: disciplineFormulas.length }, (_pd, disciplineIndex) => {

          const { formula, ...disciplineInfo } = disciplineFormulas[disciplineIndex];

          const existingDiscipline = disciplines.find(x => x.disciplineId == disciplineInfo.disciplineId);

          if (!existingDiscipline) {
            disciplines.push(disciplineInfo);
          }

          Array.from({ length: formula.length }, (_pdd, formulaIndex) => {
            const item = formula[formulaIndex];
            if (item.termInfo) {
              const existing = evaluationTypes.find(x => x.termInfo.tokenTermIndex == item.termInfo.tokenTermIndex && x.termInfo.id == item.termInfo.id);
              if (!existing) {
                evaluationTypes.push(item);
              }
            }
          });
        });
        formulaData[periodIndex].evaluationTypes = evaluationTypes;
      });
    });

    this.setState({ evaluationsData: evaluationsData, currentStudentId: studentId, formulaData: formulaData, disciplines: disciplines, periods: periods, loading: false });

  }

  loadEvaluationFromState = (evaluationItemData,) => {
    let { evaluationsData } = this.state;

    return evaluationsData.find(x => getEvaluationUniqueKey(x) === getEvaluationUniqueKey(evaluationItemData)) || {};
  }

  loadEvaluationField = (evaluationItem, fieldName = "points") => {
    const stateData = this.loadEvaluationFromState(evaluationItem);
    return stateData[fieldName] || undefined;
  }

  setEvaluationData = (evaluationItemData) => {
    const { evaluationsData } = this.state;

    const uniqueKey = getEvaluationUniqueKey(evaluationItemData);

    let otherEvaluations = evaluationsData.filter(x =>
      getEvaluationUniqueKey(x) !== uniqueKey
    ) || [];

    let newEvaluations = [...otherEvaluations, evaluationItemData];
    this.setState({ evaluationsData: newEvaluations });
  }

  handleEvaluationPointsChange = (event, otherEvaluationFields) => {
    const { value } = event.target;
    otherEvaluationFields.points = value;
    const uniqueKey = getEvaluationUniqueKey(otherEvaluationFields);

    this.setEvaluationData(otherEvaluationFields);

    this.setState(prevState => ({
      pendingSaves: {
        ...prevState.pendingSaves,
        [uniqueKey]: otherEvaluationFields
      },
      saveStatus: 'pending'
    }), () => {
      this.debouncedAutoSave();
    });
  }

  modalSubmit = async () => {
    const { id } = this.props.match.params;
    const { studentId } = this.state.form;

    const { students } = this.state;

    const item = students.find(x => x.student.id == studentId);

    const registration = item.student?.registration ?? item.studentId ?? "";
    const displayName = item.student.person?.displayName ?? "";

    this.closeStudentSelectModal();
    this.setState({ loading: true, currentStudentRegistration: registration, currentStudentName: displayName, evaluationsData: [], pendingSaves: {}, saveStatus: EVALUATION_AUTOSAVE_STATUS_IDLE });

    await this.loadData(id, studentId);
  }


  openStudentSelectModal = () => {
    this.setState({ showStudentSelectModal: true });
  }

  closeStudentSelectModal = () => {
    this.setState({ showStudentSelectModal: false });
  }

  renderEvaluationTypeDisplayName = (evaluationTypeItem, evaluationTypeList) => {
    const hasMore = evaluationTypeList.find(x => x.termInfo.id == evaluationTypeItem.termInfo.id && x.termInfo.tokenTermIndex != evaluationTypeItem.termInfo.tokenTermIndex);

    if (!hasMore) {
      return evaluationTypeItem.termInfo.displayName;
    }

    return `${evaluationTypeItem.termInfo.displayName} ${evaluationTypeItem.termInfo.tokenTermIndex}`;
  }

  renderEvaluationField = (discipline, period, evaluationType) => {
    const { formulaData, classroom, currentStudentId } = this.state;
    const { academicPeriodId, id: classroomId } = classroom;

    let evaluationFields = {
      studentId: currentStudentId,
      classroomId: classroomId,
      academicPeriodId: academicPeriodId,
      disciplineId: discipline.disciplineId,
      evaluationPeriodId: period.periodId,
      evaluationTypeId: evaluationType.termInfo.id,
      evaluationTypeIndex: evaluationType.termInfo.tokenTermIndex
    };

    const periodInfo = formulaData.find(x => x.periodId == period.periodId);
    const disciplineInfo = periodInfo.disciplineFormulas.find(x => x.disciplineId == discipline.disciplineId);

    let hasEvaluationType = disciplineInfo.formula.find(x => x.displayName == evaluationType.displayName);

    if (!hasEvaluationType) {
      return "N/A";
    }

    const inputKey = getEvaluationUniqueKey(evaluationFields);

    return <Form.Control
      type="text"
      id={`ev-${inputKey}`}
      name={`evaluation_${inputKey}`}
      defaultValue={this.loadEvaluationField(evaluationFields, "points")}
      onChange={(e) => this.handleEvaluationPointsChange(e, evaluationFields)}
      onBlur={() => this.debouncedAutoSave()}
    />;
  }


  autoSaveEvaluation = async () => {
    const { pendingSaves } = this.state;
    const itemsToSave = Object.values(pendingSaves);
    let autoSaveErrorMessage = '';

    if (itemsToSave.length === 0) {
      this.setState({ saveStatus: EVALUATION_AUTOSAVE_STATUS_IDLE });
      return;
    }


    this.setState({ saveStatus: EVALUATION_AUTOSAVE_STATUS_SAVING, pendingSaves: {} });

    try {
      let allSucceeded = true;

      for (const item of itemsToSave) {
        await evaluationsService.autoSave(item).then((result) => {
          if (result.error === true) {
            allSucceeded = false;
            autoSaveErrorMessage = result.message;
          }
        });
        if (!allSucceeded) {
          break;
        }
      }

      if (allSucceeded) {
        this.setState({
          saveStatus: EVALUATION_AUTOSAVE_STATUS_SAVED,
        });

        setTimeout(() => {
          this.setState({ saveStatus: EVALUATION_AUTOSAVE_STATUS_IDLE });
        }, 3000);
      } else {
        this.setState({
          saveStatus: EVALUATION_AUTOSAVE_STATUS_ERROR,
          autoSaveMessage: `Falha no autosave`,
        });
      }

    } catch (error) {
      this.setState({
        saveStatus: EVALUATION_AUTOSAVE_STATUS_ERROR,
        autoSaveMessage: `Falha no autosave: ${error}`,
      });
    }
  }


  renderSaveStatus = () => {
    const { saveStatus, autoSaveMessage } = this.state;
    let text = '';
    let variant = 'secondary';
    let icon = '';

    switch (saveStatus) {
      case EVALUATION_AUTOSAVE_STATUS_PENDING:
        text = 'Aguardando...';
        variant = 'warning';
        break;
      case EVALUATION_AUTOSAVE_STATUS_SAVING:
        text = 'Salvando...';
        variant = 'info';
        break;
      case EVALUATION_AUTOSAVE_STATUS_SAVED:
        text = 'Dados atualizados';
        variant = 'success';
        break;
      case EVALUATION_AUTOSAVE_STATUS_ERROR:
        text = autoSaveMessage;
        variant = 'danger';
        break;
      case 'idle':
      default:
        return null;
    }

    return (
      <div
        className={`alert alert-${variant} d-inline-block p-2 me-2 float-end`}
        role="alert"
        style={{ fontSize: '0.9rem', marginBottom: 0, marginLeft: "10px", padding: '0.5rem 1rem' }}
      >
        {text}
      </div>
    );
  }

  render() {
    const { id: classroomId } = this.props.match.params;

    const { loading, actionLoading, error, message, showStudentSelectModal, classroom, formulaData, disciplines, periods, currentStudentName, currentStudentRegistration } = this.state;

    const { name: classroomName } = classroom;

    const { openStudentSelectModal, closeStudentSelectModal, modalSubmit, renderEvaluationTypeDisplayName, renderEvaluationField, renderSaveStatus } = this;

    const component = this;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && periods.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
        {loading === false && error == false && (
          <Container>
            <Row>
              <h4>
                {classroom.name} / Lançamento de nota por aluno
                <ChangeButton
                  title="Escolher aluno"
                  containerProps={{
                    onClick: () => openStudentSelectModal()

                  }}
                />
                {renderSaveStatus()}
              </h4>
              <Container>
                <p>Aluno {`${currentStudentName} - Matrícula: ${currentStudentRegistration}`}</p>
                <Table className="mt-4">
                  <thead>
                    <tr>
                      <th></th>
                      {periods.map((period, pi) => {
                        const periodEvaluationTypes = formulaData.find(x => x.periodId == period.periodId).evaluationTypes || [];
                        return <th key={pi} colSpan={periodEvaluationTypes.length}>{period.periodName}</th>
                      })}
                    </tr>
                    <tr>
                      <th></th>
                      {periods.map((period, _pi) => {
                        const periodEvaluationTypes = formulaData.find(x => x.periodId == period.periodId).evaluationTypes || [];
                        return periodEvaluationTypes.map((evt, eti) => { return <th key={eti}>{renderEvaluationTypeDisplayName(evt, periodEvaluationTypes)}</th> });
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {disciplines.map((discipline, di) => {
                      return (
                        <tr key={di}>
                          <td>{discipline.disciplineName}</td>
                          {periods.map((period, _pi) => {
                            const periodEvaluationTypes = formulaData.find(x => x.periodId == period.periodId).evaluationTypes || [];
                            return periodEvaluationTypes.map((evt, eti) => { return <th key={eti}>{renderEvaluationField(discipline, period, evt)}</th> });
                          })}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Container>
            </Row>
            <SelectStudentEvaluationModal
              show={showStudentSelectModal}
              onClose={closeStudentSelectModal}
              onSubmit={modalSubmit}
              classroomId={classroomId}
              classroomName={classroomName}
              component={component}
            />
          </Container>
        )}
        <Container>
          <div className="mt-3">
            <CancelButton
              containerProps={{
                as: Link,
                to: `/turmas`
              }}
            />
          </div>
        </Container>
      </div>
    );
  };
}

export default ClassroomEvaluateStudentMain;
